import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import styles from './styles.module.css';
import WhiteboardController from './controllers/WhiteboardController';

const ConnectorPointMenu = () => {
  const controller = useController(WhiteboardController);
  const { connectorPointMenu } = controller.state;

  if (connectorPointMenu != null) {
    return (
      <aha-menu
        open
        style={{
          position: 'absolute',
          left: connectorPointMenu.x,
          top: connectorPointMenu.y,
        }}
      >
        <div slot='control' />
        <aha-menu-content>
          <aha-menu-item
            onClick={() => {
              connectorPointMenu.object.removePointAtIndex(
                connectorPointMenu.pointIndex
              );
            }}
          >
            <a className={styles.menuItemWithShortcut}>
              <span className={styles.menuItemName}>Remove point</span>
            </a>
          </aha-menu-item>
        </aha-menu-content>
      </aha-menu>
    );
  } else {
    return null;
  }
};

export default ApplicationView(ConnectorPointMenu);
